import {APP_INITIALIZER} from '@angular/core';
import {firstValueFrom, of} from 'rxjs';
import {UrlTree} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {CookieXAuthToken} from "./constants/auth-dictionary.enum";
import {AuthService} from "./services/auth.service";

export function initializeApp(
  cookieService: CookieService,
  authService: AuthService
): () => Promise<void | UrlTree> {
  return () => {
    const authToken = cookieService.get(CookieXAuthToken);
    if (authToken) {
      authService.setToken(authToken);
    }
    return firstValueFrom(of(undefined));
  };
}

export const appInitializer = {
  provide: APP_INITIALIZER,
  useFactory: initializeApp,
  deps: [CookieService, AuthService],
  multi: true,
};
